import DMAStorageService from "services/DMAStorageService";
const getAutoplayRegistryFromLocalStorage = () => {
    const registryName = `continuous_play_${CBS.Registry.user.profile_id}`;
    const registryValue = localStorage.getItem(registryName);
    return registryValue == 'true' || !registryValue ? true : false;
};

export const getContinuousPlayEnabledStatus = (continousPlayFlag) => {
    return getAutoplayRegistryFromLocalStorage() && continousPlayFlag == 1;
};

export const getContinuousPlayEnabledTrackingStatus = () => {
    const autoPlayEnabled = getAutoplayRegistryFromLocalStorage();
    return autoPlayEnabled == true ? '1' : '0';
};

export const getLiveEndcardDma = () => {
    const DMAStorage = new DMAStorageService();
    const dmaInfo = DMAStorage.getStorageDMA();
    return dmaInfo[0].dma ?? 0;
}
